// @flow

import Resource from 'speed-js-core/src/api/NestedResource';

export default class AvailablePatrolsResource extends Resource {
    basePath: string = 'cases/cases/{parent}/patrols/available/';
}
